import { Spin } from 'antd';

const Loader = ({
  size = 'large',
  tip = 'Loading...',
  fullScreen = false,
}: {
  size?: 'small' | 'default' | 'large';
  tip?: string;
  fullScreen?: boolean;
}) => {
  return (
    <div className={`flex flex-col items-center justify-center p-20 ${fullScreen ? 'h-screen' : ''}`}>
      <Spin size={size} tip={tip} />
    </div>
  );
};

export default Loader;
